import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import {
  CANCEL_BUTTON_TEXT,
  SWITCH_LOCATION_CONFIRM_BUTTON_TEXT,
} from "../../constants/button-messages";
import {
  Dialog,
  DialogActions,
  DialogScroll,
  DialogTitle,
  DialogTitleActions,
  Type,
  RadioGroup,
  Card,
  CardContent,
} from "@ebscois/react-component-library";
import ErrorBoundary from "../ErrorBoundary";
import { assignReturnToUrlForSwitchLocation } from "../../util/url-utils";

import { StyledLocationsRadio, StyledButton } from "./SwitchLocation.styled";

function renderProfilesList(profiles) {
  if (profiles && profiles.length) {
    return profiles.map((profile) => {
      return (
        <StyledLocationsRadio
          data-testid="SelectorRadioItem"
          name={profile.customerName}
          label={profile.customerName}
          id={profile.profNumber}
          value={profile.profNumber}
          key={profile.profNumber}
        />
      );
    });
  }
}

function SwitchLocation(props) {
  const { setIsOpen, availableProfiles, isOpen } = props;
  const selectedProfile = useMemo(() => {
    return availableProfiles.find((profile) => profile.isSelected);
  }, [availableProfiles]);
  const [selectedProfileId, setSelectedProfileId] = useState(
    selectedProfile?.profNumber || ""
  );
  function handleSelect(e) {
    setSelectedProfileId(e.target.value);
  }

  function handleClose() {
    setIsOpen(false);
    setSelectedProfileId(selectedProfile.profNumber);
  }

  function handleConfirm(e) {
    if (selectedProfileId !== selectedProfile?.profNumber) {
      const newLocation = assignReturnToUrlForSwitchLocation(selectedProfileId);
      if (newLocation) {
        window.location = newLocation;
      }
    }
  }

  return (
    <ErrorBoundary team="cd.ghostriders">
      <Dialog
        background="black"
        data-testid="ModalWindow"
        isOpen={isOpen}
        maxWidth="md"
        onRequestClose={handleClose}
        showCloseButton
      >
        <DialogTitle
          borderBottomColor="gray300"
          borderBottomStyle="solid"
          borderBottomWidth="1px"
        >
          <Type
            element="h2"
            fontFamily="secondary"
            fontSize="lg"
            color="gray800"
          >
            Switch Location
          </Type>
          <DialogTitleActions onRequestClose={handleClose} />
        </DialogTitle>
        <DialogScroll>
          <Card>
            <CardContent>
              <Type paddingBottom="sm" data-testid="SwitchLocationText">
                Switching allows you to access a different location's view of
                the website.
              </Type>
              <RadioGroup
                name="availableProfiles"
                onChange={handleSelect}
                selectedValue={selectedProfileId}
              >
                {renderProfilesList(availableProfiles)}
              </RadioGroup>
            </CardContent>
          </Card>
        </DialogScroll>
        <DialogActions
          borderTopColor="gray300"
          borderTopStyle="solid"
          borderTopWidth="1px"
          justify="left"
        >
          <>
            <StyledButton
              variant="primary"
              onClick={handleConfirm}
              disabled={selectedProfileId === selectedProfile?.profNumber}
              data-testid="ConfirmSwitchLocation"
            >
              {SWITCH_LOCATION_CONFIRM_BUTTON_TEXT}
            </StyledButton>
            <StyledButton
              kind="text"
              onClick={handleClose}
              data-testid="CancelSwitchLocation"
            >
              {CANCEL_BUTTON_TEXT}
            </StyledButton>
          </>
        </DialogActions>
      </Dialog>
    </ErrorBoundary>
  );
}

SwitchLocation.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  availableProfiles: PropTypes.array.isRequired,
};

SwitchLocation.displayName = "PuaDialog";
export default SwitchLocation;
